export default "__VITE_ASSET__DsVBMwUq__"